export default __webpack_public_path__ + "static/media/taha.81ed5579.png";